<template>
  <div v-show="show">
    <div class="modal-backdrop"></div>
    <div class="dialog-outer">
      <div class="dialog-inner">
        <a href="javascript:;" v-if="closable" class="close iconfont" @click="dismiss">&#xe611;</a>
        <div class="dialog-main">
          <div class="dialog-content" v-if="simple">
            <p class="dialog-msg"></p>
            <a :href="link" :title="linkTitle" class="btn btn-primary" @click="onClick">{{btnText}}</a>
          </div>
          <div class="dialog-body"><slot></slot></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Modal',
    props: {
      show: {
        type: Boolean,
        default: false
      },
      closable: {
        type: Boolean,
        default: true
      },
      simple: {
        type: Boolean,
        default: false
      },
      link: {
        type: String,
        default: 'javascript:;'
      },
      linkTitle: String,
      btnText: {
        type: String,
        default: '确定'
      }
    },
    methods: {
      dismiss (e) {
        this.$emit('dismiss', e)
      },
      onClick (e) {
        this.$emit('onClick', e)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// modal.vue?a47a106e